angular.module('LeasePilot').directive('createConformedDeal', [
  '$mdDialog',
  '$http',
  function($mdDialog, $http) {
    return {
      restrict: 'E',
      templateUrl: 'create_conformed_deal.html',
      link: function($scope, element, attrs) {
        function create(replace) {
          let name = $scope.lease.customFields?.fileName || $scope.lease.tenantInfo?.tradeName || $scope.lease.tenantInfo?.name;

          $http({
            method: 'POST',
            url: '/api/leases/' + $scope.lease.id + '/create_conformed_deal',
            data: {
              lease_id: $scope.lease.id,
              name,
              new: !replace,
            },
          }).then(
            function(response) {
              window.track.event(new SaveConformedDealEvent({
                id: $scope.lease.id,
                name: name,
              }));

              window.track.event(new CreateNewConformedDealEvent({
                id: response.data.id,
                name: name,
              }));

              location.href = '/leases';
            },
            function(error) {
              if (
                error.status == 422 &&
                error.data.error === 'conformed deal already exists'
              ) {
                confirmSaveAsConformedDeal();
              }
            },
          );
        }

        $scope.saveConformedDeal = function($event) {
          create(false);
        };

        function confirmSaveAsConformedDeal() {
          let name = $scope.lease.customFields?.fileName || $scope.lease.tenantInfo?.tradeName || $scope.lease.tenantInfo?.name;

          // The `create_conformed_deal` is a link instead of $http request
          $mdDialog.show({
            controller:
              ('DialogController', ['$scope', '$mdDialog', '$http', DialogController]),
            template:
              '<div class="md-dialog-content confirm-modal">' +
              '<p class="title" >Confirm Save As Conformed Deal</p>' +
              '<p class="message">' +
              name +
              ' Lease Conformed Deal already exists. Do you want to override it?</p>' +
              '<div class="modal-actions">' +
              '<button class="btn blue" ng-click="yes()">Yes</button>' +
              '<button class="btn blue-outline" ng-click="no()">No</button>' +
              '</div>' +
              '</div>',
            clickOutsideToClose: true,
            fullscreen: false,
          });
          function DialogController($scope, $mdDialog, $http) {
            $scope.yes = function() {
              create(true);
              $mdDialog.cancel();
            };
            $scope.no = function() {
              $mdDialog.cancel();
            };
          }
        }
      },
    };
  },
]);
